import axios from "axios";

export const createMarketing = async (marketing) => {
    const response = await axios.post(`/api/marketing`, { marketing });
    return response.data;
};

export const updateMarketing = async marketing => {
    const response = await axios.put(`/api/marketing`, { marketing });
    return response.data;
};

export const getMarketing = async id => {
    const response = await axios.get(`/api/marketing/${id}`);
    return response.data;
};

export const getMarketingMatch = async marketing => {
    const response = await axios.post(`/api/marketing-match`, { marketing });
    return response.data;
};

export const deleteMarketing = async id => {
    const response = await axios.delete(`/api/marketing/${id}`);
    return response.data;
};
